import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { Step } from "../Step";
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var Steps = /*#__PURE__*/memo(function (_ref) {
  var _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Steps' : _ref$testName,
    _ref$isClickable = _ref.isClickable,
    isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
    items = _ref.items,
    onChange = _ref.onChange,
    transitionTime = _ref.transitionTime,
    selectedStep = _ref.selectedStep;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('steps'),
    "data-component": testName,
    "data-t-id": "src-Steps"
  }, items.map(function (item, index) {
    var _items;
    return /*#__PURE__*/React.createElement("li", {
      className: cn('steps__item'),
      itemProp: "step",
      itemScope: true,
      itemType: "https://schema.org/HowToStep",
      key: item.id
    }, /*#__PURE__*/React.createElement(Step, {
      customDescription: item === null || item === void 0 ? void 0 : item.customDescription,
      description: item === null || item === void 0 ? void 0 : item.description,
      id: item.id,
      isClickable: isClickable,
      nextId: ((_items = items[index + 1]) === null || _items === void 0 ? void 0 : _items.id) || items[0].id,
      onClick: onChange,
      selected: selectedStep === item.id,
      stepNumber: index + 1,
      title: item.title,
      transitionTime: transitionTime
    }));
  }));
});
Steps.displayName = Steps.name;